// extracted by mini-css-extract-plugin
export default {"crossIcon":"style_crossIcon__FUgPk","title":"style_title__Of72b","textarea":"style_textarea__E+TFf","btn":"style_btn__bm4ZC","ratingContainer":"style_ratingContainer__PN-4h"};